import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const IT_SERVICES_DOMAIN_INTRO = {
  title: "IT & Technology Services",
  content: "Agentic AI workflow automation for IT & Technology Services — across IT Services, IT Operations, IT Governance, Software Engineering, Product Engineering, Cybersecurity, and DevOps. Use cases span IT service desk triage, incident root cause assistance, change request risk analysis, test case generation, release notes automation, SOC alert enrichment, RFP response assistance, pipeline failure triage, and employee onboarding access workflows. Practical deployments for IT services firms in India, UAE, KSA, UK, and USA with human-in-the-loop review, status tracking, and audit evidence.",
  seoDescription: "IT technology services agentic AI — IT service desk triage, incident root cause, change request risk, test case generation, release notes, SOC alert enrichment, RFP response, pipeline failure triage, onboarding access workflow. ITSM DevOps SIEM CRM integration.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const IT_SERVICES_SYSTEMS = "ITSM, DevOps, SIEM, CRM, Document Management, Email, Power BI";

const RAW = [
  {
    id: "incident-root-cause-assistant",
    subIndustry: "IT Operations",
    department: "Incident Management",
    businessProcess: "Incident root cause assistant",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Incident root cause assistant",
    title: "Incident Root Cause Assistant Automation for IT & Technology Services",
    seoKeywords: "it & technology services, incident root cause assistant, AI automation, RPA, agentic AI",
    challenge: "Engineers manually review logs, alerts, tickets and recent changes during incidents.",
    solution: "Implement Agentic AI + Data Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "IT Operations teams can improve incident root cause assistant with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Data Automation",
    buyerPersona: "IT Operations Head, CTO",
    systems: IT_SERVICES_SYSTEMS,
    agentsRequired: "Data Collection Agent, Incident Insight Agent, Alert Agent",
    inputData: "System exports, transaction records, logs, historical data, master data and incident root cause assistant business rules",
    outputActions: "Dashboard, anomaly alerts, forecast or action list for incident root cause assistant",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "12+ months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "soc-alert-enrichment",
    subIndustry: "Cybersecurity",
    department: "SOC",
    businessProcess: "SOC alert enrichment",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "SOC alert enrichment",
    title: "Soc Alert Enrichment Automation for IT & Technology Services",
    seoKeywords: "it & technology services, soc alert enrichment, AI automation, RPA, agentic AI",
    challenge: "Analysts manually enrich alerts using logs, asset data and threat intelligence.",
    solution: "Implement Agentic AI + Data Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Cybersecurity teams can improve soc alert enrichment with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Data Automation",
    buyerPersona: "CISO, SOC Head",
    systems: IT_SERVICES_SYSTEMS,
    agentsRequired: "Data Collection Agent, SOC Insight Agent, Alert Agent",
    inputData: "System exports, transaction records, logs, historical data, master data and soc alert enrichment business rules",
    outputActions: "Dashboard, anomaly alerts, forecast or action list for soc alert enrichment",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "12+ months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "rfp-response-assistant",
    subIndustry: "IT Services",
    department: "Sales",
    businessProcess: "RFP response assistant",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "RFP response assistant",
    title: "Rfp Response Assistant Automation for IT & Technology Services",
    seoKeywords: "it & technology services, rfp response assistant, AI automation, RPA, agentic AI, document AI",
    challenge: "Sales teams manually search past proposals, credentials and solution content for RFP responses.",
    solution: "Implement Agentic AI + Document AI to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "IT Services teams can improve rfp response assistant with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Document AI",
    buyerPersona: "Sales Head, Presales Head",
    systems: IT_SERVICES_SYSTEMS,
    agentsRequired: "Document Extraction Agent, RFP Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and rfp response assistant rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready rfp response assistant record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "pipeline-failure-triage",
    subIndustry: "DevOps",
    department: "Platform Engineering",
    businessProcess: "Pipeline failure triage",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Pipeline failure triage",
    title: "Pipeline Failure Triage Automation for IT & Technology Services",
    seoKeywords: "it & technology services, pipeline failure triage, AI automation, RPA, agentic AI",
    challenge: "Engineers manually review CI/CD failures, logs and configuration changes.",
    solution: "Implement Agentic AI + DevOps Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "DevOps teams can improve pipeline failure triage with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + DevOps Automation",
    buyerPersona: "DevOps Head",
    systems: IT_SERVICES_SYSTEMS,
    agentsRequired: "Pipeline AI Agent, Validation Agent, Human Review Agent",
    inputData: "Emails, forms, system records, task notes, master data and pipeline failure triage process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for pipeline failure triage",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "employee-onboarding-access-workflow",
    subIndustry: "IT Services",
    department: "HR and IT",
    businessProcess: "Employee onboarding access workflow",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Employee onboarding access workflow",
    title: "Employee Onboarding Access Workflow Automation for IT & Technology Services",
    seoKeywords: "it & technology services, employee onboarding access workflow, AI automation, RPA, agentic AI",
    challenge: "New hire accounts, devices and application access are coordinated manually.",
    solution: "Implement Agentic AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "IT Services teams can improve employee onboarding access workflow with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + RPA",
    buyerPersona: "HR Head, IT Operations Head",
    systems: IT_SERVICES_SYSTEMS,
    agentsRequired: "RPA Posting Agent, Employee Validation Agent, Exception Agent",
    inputData: "Emails, forms, system records, task notes, master data and employee onboarding access workflow process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for employee onboarding access workflow",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const IT_SERVICES_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["IT Operations", "Cybersecurity", "IT Services", "DevOps"];
export const IT_SERVICES_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => IT_SERVICES_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'it-services-domain', domainIntro: IT_SERVICES_DOMAIN_INTRO, useCases: IT_SERVICES_USE_CASES });
export const IT_SERVICES_USE_CASES_SEO = seo.useCasesSeo;
export const IT_SERVICES_DOMAIN_FAQS = seo.domainFaqs;
export const IT_SERVICES_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const IT_SERVICES_FAQ_JSONLD = seo.faqJsonLd;
export const IT_SERVICES_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const IT_SERVICES_WEBPAGE_JSONLD = seo.webPageJsonLd;

